import { render, staticRenderFns } from "./SupplierIndex.vue?vue&type=template&id=6398d7ce&scoped=true&"
import script from "./SupplierIndex.vue?vue&type=script&lang=js&"
export * from "./SupplierIndex.vue?vue&type=script&lang=js&"
import style0 from "./SupplierIndex.vue?vue&type=style&index=0&id=6398d7ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398d7ce",
  null
  
)

export default component.exports